import React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import FormControl from '@mui/material/FormControl';

export const MonthPickerBox = (props) => {
  const { value, onChange, meta } = props;

  const handleChange = (new_value) => {
    console.log('handleChange', new_value);
    onChange(new_value, meta.key);
  };

  const renderStyle = () => {
    if (meta.style) {
      return { ...meta.style };
    } else {
      return {};
    }
  };

  return (
    <article className='form-date-picker-box' style={renderStyle()}>
      <header>
        <span>
          {meta.label} {meta.required ? '*' : ''}
        </span>
      </header>
      <FormControl fullWidth={meta.fullWidth}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={['year', 'month']}
            inputFormat={'yyyy-MM'}
            mask={'____-__'}
            disableMaskedInput={true}
            disabled={meta.disabled}
            readOnly={meta.readOnly}
            label={meta.label}
            value={value}
            onChange={handleChange}
            renderInput={(params) => <TextField required={meta.required} {...params} />}
          />
        </LocalizationProvider>
      </FormControl>
    </article>
  );
};
